<template>
  <div id="app">
    <!-- <div class="banner">
      <picture v-if="$i18n.locale === 'ar'">
        <source media="(max-width: 767px)" srcset="@/assets/img/ar-banner-mobile.jpg">
        <source srcset="@/assets/img/ar-banner-desktop.jpg">
        <img src="@/assets/img/ar-banner-mobile.jpg" alt="banner">
      </picture>
      <picture v-if="$i18n.locale === 'fr'">
        <source media="(max-width: 767px)" srcset="@/assets/img/fr-banner-mobile.jpg">
        <source srcset="@/assets/img/fr-banner-desktop.jpg">
        <img src="@/assets/img/fr-banner-mobile.jpg" alt="banner">
      </picture>
    </div> -->
    <AppHeader />
    <main>
      <router-view />
    </main>
    <AppFooter />
    <HelpWidget />
  </div>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    AppHeader : () => import('@/components/AppHeader'),
    AppFooter : () => import('@/components/AppFooter'),
    HelpWidget: () => import('@/components/HelpWidget')
  },
  methods: {
    loadData: function() {
      axios.get('https://succursalesrenault.ma/onlinestore/admin/public/api/shopsucc')
        .then(({data}) => data.filter(brand => brand.LibelleMarque.toUpperCase() === process.env.VUE_APP_THEME.toUpperCase())[0])
          .then(({RefModeles}) => this.$store.dispatch('setModels', RefModeles))
          .catch(err => console.error(err))
    }
  },
  created() {
    localStorage.removeItem('vuex')
    document.querySelector('html').classList.add(`theme-${process.env.VUE_APP_THEME}`)
    this.loadData()
    this.$store.dispatch('setUTMs', {
      source  : this.getQueryStringParams('utm_source'),
      campaign: this.getQueryStringParams('utm_campaign'),
      medium  : this.getQueryStringParams('utm_medium'),
      content : this.getQueryStringParams('utm_content')
    })
    axios.get('https://www.succursalesrenault.ma/onlinestore/admin/public/api/packs')
      .then(({status, data}) => {
        if (status === 200) {
          this.$store.dispatch('setAccessoriesList', data.map(acc => ({...acc, selected: false })))
        }
      })
    .catch(err => console.error(err))
    axios.get('https://www.succursalesrenault.ma/onlinestore/admin/public/api/options')
      .then(({status, data}) => {
        if (status === 200) {
          this.$store.dispatch('setOptionsList', data.map(op => ({...op, selected: false })))
        }
      })
    .catch(err => console.error(err))
    axios.get('https://succursalesrenault.ma/onlinestore/admin/public/api/popin-state')
      .then(({status, data}) => {
        if (status === 200) this.$store.dispatch('setMaintenance', data)
      })
    .catch(err => console.error(err))
    const query = this.$route.query
    if (query.trade === 'true') this.$store.dispatch('setTrade', query)
  },
  mounted() {
    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) return
        document.documentElement.lang = newLocale
        document.dir = newLocale === 'ar' ? 'rtl' : 'ltr'
      },
      { immediate: true }
    )
    this.$store.watch(
      () => this.$store.getters.total
      , total => {
        if (this.$store.getters.mensualite) {
          this.$store.dispatch('setMonthlyPayment', '')
          EventBus.$emit('mensualite-changed')
        }
      }
    )
  }
}
</script>

<style lang="scss">
#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  main {
    flex: 1;
  }
  // .banner {
  //   background: $white;
  //   border-bottom: rem(1) solid darken($gray, 20%);
  //   img {
  //     display: table;
  //     width: 100%;
  //     max-width: max-content;
  //     margin: 0 auto;
  //   }
  // }
}
</style>
